export default __webpack_public_path__ + "static/media/DSC_8093-edited-darker.49d6cb60.png";